export const DOCUMENT_DELIVERY: string = 'documents-delivery';
export const TRACKED_DOCUMENTS_LIST: string = 'tracked-documents-list';
export const TRACKED_DOCUMENTS_LIST_ALL: string = 'Company';
export const ALL: string = 'All';
export const USER_PANEL: string = 'UserPanel';
export const ACCOUNT_SETTINGS: string = 'AccountSettings';
